enum EBreadcrumb {
  ja,
  en,
  zh,
  vi,
  pt,
  my,
  id,
  ne,
}

export const API_LANGUAGE_MAP = {
  en: "en_us",
  ja: "ja_jp",
  zh: "zh_cn",
  vi: "vi_vn",
  pt: "pt_pt",
  my: "my_mm",
  id: "id_id",
  ne: "ne_np",
};

export function getEnumByLocale(locale: string): number {
  return EBreadcrumb[(locale as keyof typeof EBreadcrumb) || "ja"];
}
